import React from 'react';

import { Tooltip } from "components";
import { FormControlLabel } from "@mui/material";
import { IOSSwitch } from './switch-ios';

export const SwitchToActivation = ({
  row,
  textOn,
  textOff,
  onChange,
  onClick
}: {
  row: any,
  textOn: string,
  textOff: string,
  onChange?: () => void,
  onClick?: (e: any) => void
}) => {
  const { enabled } = row;
  return (
    <Tooltip arrow placement="top" title={enabled ? textOn : textOff}>
      <FormControlLabel
        sx={{
          margin: 0,
        }}
        control={
          <IOSSwitch
            size="small"
            checked={enabled}
            onChange={onChange}
            onClick={onClick}
          />
        }
        label=""
      />
    </Tooltip>
  )
}
